module.exports = __webpack_public_path__ + "img/donut_large-24px.svg";